import { type UseQueryResult, useQuery } from 'react-query';
import { CsBrokerTradeToolService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetCsBookingTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<Array<{ label: string; value: string }> | undefined, unknown> => {
  return useQuery(['getCsBookingTypes'], async () => {
    return await handleRequest(
      CsBrokerTradeToolService.getApiAwardApiAppCsBrokerTradeToolBookingTypes()
    );
  });
};

export default useGetCsBookingTypes;
